"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hook = {
    beforeEach: function ($store, to, _from) {
        if (to && to.query && to.query.agencyId) {
            $store.commit('tracking/bea/SET_AGENCY_ID', to.query.agencyId);
        }
        var store = $store;
        if (!store._actions['booking/affiliate/IMPORT']) {
            return;
        }
        $store.dispatch('booking/affiliate/IMPORT', { route: to });
        // now implemented in init, here for reference
        // if ( to.query.utm_medium && to.query.affID2 ) {
        //  $store.dispatch('tracking/bea/setAffilliate', to.query.affID2)
        //}
    },
    afterEach: function (_$store, _to, _from) { },
};
exports.default = hook;
//# sourceMappingURL=routing.js.map